module.exports = __webpack_public_path__ + "img/page43.bf313be2.gif";